import Component from './src/Footer';

export * from './src/Footer';
export default Component;
